export namespace KycCheckpointId {
  export const Identity = 1n;
  export const VerifiedTaxId = 2n;
  export const DocumentSubmission = 3n;
  export const AddressVerification = 4n;
  export const ProofOfResidence = 5n;
  export const ProofOfIncome = 6n;
  export const CriminalRecordCheck = 7n;
  export const VerifiedEmail = 8n;
  export const VerifiedPhoneNumber = 9n;
}

export type KycCheckpointIdType =
  (typeof KycCheckpointId)[keyof typeof KycCheckpointId];
